var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"root"}},[_c('Head'),_c('Search'),_c('Nav'),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }